export default __webpack_public_path__ + "static/short-statement-do-3fbb91628618de83a8dbafbccd2e1625.png";